import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './MojeDokumenty.css';
import { Row, Col, PageHeader, Pagination, Table, Tooltip, OverlayTrigger } from 'react-bootstrap';
import fetch from '../../core/fetch';
import waiting from './waiting-wheel-300x300.gif';
import GrayPanel from '../../components/GrayPanel';
import DatePicker from 'react-bootstrap-date-picker';
import Link from '../../components/Link';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage, isMobileView, isTabletView } from '../../components/utils/utils';

const mappedKeys = {
  shortName: 'Nazwa',
  timeStart: 'Początek',
  timeEnd: 'Koniec',
  jobId: 'Id zadania',
  userType: 'Typ',
  docReason: '',
  status: 'Status',
  paymentStatus: 'Status płatności',
  teryt: 'Urząd',
  wniosekFileName: 'Nazwa wniosku',
  motionSendDate: 'Data złożenia wniosku',
  fk_userID: 'ID użytkownika',
};

const buttonPayStyle = {
  padding: '2px 2px',
  marginLeft: '0px',
};

const polishMonthLabels = [
  'Styczeń',
  'Luty',
  'Marzec',
  'Kwiecień',
  'Maj',
  'Czerwiec',
  'Lipiec',
  'Sierpień',
  'Wrzesień',
  'Październik',
  'Listopad',
  'Grudzień',
];
const polishDayLabels = ['Niedz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'So'];

const eServicesInPolish = {
  waiting: 'oczekuje',
  success: 'zapłacono',
};

const operator_map = {
  Przed: 'lt',
  Po: 'gt',
  Równe: 'equal',
};

const col_header_map = {
  shortName: 'Krótka nazwa',
  isSigned: 'Czy podpisany',
  timeStart: 'Data',
  status: 'Status',
  paymentStatus: 'Status płatności',
  teryt: 'Jednostka',
  parcels: 'Działki',
  docCount: 'Liczba dokumentów',
  actions: 'Dokumenty',
};

const orderingOptions = [
  {
    label: 'Krótka nazwa A-Z',
    value: 'shortName',
  },
  {
    label: 'Krótka nazwa Z-A',
    value: 'shortName desc',
  },
  {
    label: 'Data - od najnowszej',
    value: 'date desc',
  },
  {
    label: 'Data - od najstarszej',
    value: 'date',
  },
];

class MojeDokumenty extends React.Component {
  state = {
    apply_button_disabled: true,
    per_page: 25,
    docs_page_counter: 25,
    page: 1,
    info_request: null,
    filters: null,
    date: null,
    format: 'YYYY-MM-DD',
    inputFormat: 'DD/MM/YYYY',
    mode: 'date',
    focused: true,
    operator: 'lt',
    status: '',
    paymentStatus: '',
    selected_services: [],
    services_options: [],
    selected_districts: [],
    districts_options: [],
    pages: null,
    user_claims: null,
    visible_columns: [
      'shortName',
      'isSigned',
      'timeStart',
      'status',
      'paymentStatus',
      'teryt',
      'parcels',
      'docCount',
      'actions',
    ],
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    orderingOption: 'shortName',
    paymentMethods: [],
    isMounted: false,
  };

  dateFormat = 'pl-PL';

  formatDate = dt => {
    if (dt) {
      const data = new Date(dt);
      return data.toLocaleString(this.dateFormat);
    }
    return '';
  };

  componentDidMount() {
    let options = [];
    const urzedy = [];
    for (const v of Object.keys(this.props.districts)) {
      const elem = { label: this.props.districts[v].name, value: this.props.districts[v].teryt };
      urzedy.push(elem);
    }

    const url = `${process.env.API_URL}/eservices/allservices/`;
    fetch(url)
      .then(r => r.json())
      .then(resp => {
        options = resp;
        this.setState({ districts_options: urzedy, services_options: options }, () =>
          this.fetch_info_page(),
    );
      });

    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
      minHeight: '80vh',
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
        minHeight: '80vh',
      };
    }
    this.setState({ colors, sourceStyle, style });

    const paymentMethodsUrl = `${process.env.API_URL}/eservices/getDistrictPaymentMethods`;
    fetch(paymentMethodsUrl)
      .then(r => r.json())
      .then(resp => {
        this.setState({ paymentMethods: resp });
      });

    this.setState({ isMounted: true });
  }

  fetch_info_page = () => {
    let filtr = '';
    if (this.state.date) filtr += `&date=${this.state.date}&operator=${this.state.operator}`;
    if (this.state.status) filtr += `&status=${this.state.status}`;
    if (this.state.paymentStatus) filtr += `&paymentStatus=${this.state.paymentStatus}`;
    if (this.state.selected_districts.length) {
      filtr += `&teryt=[${this.state.selected_districts.reduce((prev, cur, i) => {
        if (i !== 0) {
          return `${prev}, ${cur.value}`;
        }
        return prev + cur.value;
      }, '')}]`;
    }
    if (this.state.selected_services.length) {
      filtr += `&services=[${this.state.selected_services.reduce((prev, cur, i) => {
        if (i !== 0) {
          return `${prev}, ${cur.value}`;
        }
        return prev + cur.value;
      }, '')}]`;
    }

    filtr += `&ordering=${this.state.orderingOption}`;

    let url = `${process.env.API_URL}/user/documents/${
      this.props.userData.ID
    }?expanded=1&per_page=${this.state.per_page}&page=${this.state.page}`;
    if (filtr) url += filtr;
    fetch(url)
      .then(r => r.json())
      .then(resp => {
        this.setState({ ...resp });
      });
  };

  terytToName = nrTeryt => {
    let name;
    for (const i of this.props.districts) {
      if (name !== undefined) {
        break;
      }
      if (i.teryt === nrTeryt) {
        name = i.name;
        break;
      }
    }
    return name;
  };

  getDateFromString = date => {
    let textDate = 'brak informacji';
    if (date) {
      const asDate = new Date(date);
      let day = asDate.getDate();
      if (day < 10) {
        day = `0${asDate.getDate()}`;
      }
      let month = asDate.getMonth() + 1;
      if (month < 10) {
        month = `0${asDate.getMonth() + 1}`;
      }
      textDate = `${day}.${month}.${asDate.getFullYear()}`;
    }
    return textDate;
  };

  logChange = e => this.setState({ selected_services: e }, () => this.fetch_info_page());
  orderingChange = (e) => {
    const orderingOption = e.value;
    this.setState({ orderingOption }, () => this.fetch_info_page());
  }

  logChangeDistrict = e => this.setState({ selected_districts: e }, () => this.fetch_info_page());
  handleChange = newDate =>
    this.setState({ date: newDate }, () => {
      if (this.state.operator && this.state.date) this.fetch_info_page();
    });

  applyButton = page => this.setState({ apply_button_disabled: true, docs_page_counter: this.state.per_page }, () => this.setPage(page));

  setPage = page => this.setState({ page }, () => this.fetch_info_page());

  changeOperator = e =>
    this.setState({ operator: e.target.value }, () => {
      if (this.state.operator && this.state.date) this.fetch_info_page();
    });
  changeStatus = e => this.setState({ status: e.target.value }, () => this.fetch_info_page());
  changePaymentStatus = e =>
    this.setState({ paymentStatus: e.target.value }, () => this.fetch_info_page());

  renderCol = (v, i, data) => {
    const buttonStyle = {
      padding: '2px 2px',
      marginLeft: '0px',
      color: layoutColorStyle[this.state.colors].color,
      backgroundColor: layoutColorStyle[this.state.colors].backgroundColor,
    };
    if (v === 'shortName') {
      const service = this.props.eservices ? this.props.eservices[data[v]] : null;
      return service ? (
        <td key={`${v}${i}`}>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="tooltip">
                <strong>Kliknij aby przejść do podsumowania</strong>
              </Tooltip>
            }
          >
            <Link to={`/paymentStatus/${data.jobId}`}>{service.title}</Link>
            {/* <a href="#">{service.title}</a> */}
          </OverlayTrigger>
        </td>
      ) : (
        <td key={`${v}${i}`}>{data[v]}</td>
      );
    }
    if (v === 'isSigned') {
      return <td key={`${v}${i}`}>{data[v] ? 'TAK' : 'NIE'}</td>;
    }
    if (v === 'timeStart') {
      return <td key={i}>{this.getDateFromString(data[v])}</td>;
    }
    if (v === 'status') {
      return <td key={`${v}${i}`}>{data[v] === 'finished' ? 'zakończony' : 'niedokończony' }</td>;
    }
    if (v === 'paymentStatus') {
      const paymentMethod = this.state.paymentMethods[data.paymentMethod];
      if (paymentMethod) {
        if (paymentMethod.label === 'Przelewem' || paymentMethod.label === 'W kasie urzędu') {
          return <td key={`${v}${i}`}>{paymentMethod.label}</td>;
        }
        if (data[v] === 'SUCCESS' || data[v] === 'STARTED') {
          const statusMap = {
            STARTED: 'niedokończona',
            PENDING: 'oczekuje',
            SUCCESS: 'opłacono',
          };
          return <td key={`${v}${i}`}>{statusMap[data[v]]}</td>;
        }
        let redirectURL = `${process.env.API_URL}/eservices/jobPayment/${
          data.jobId
          }?deliveryMethod=${data.deliveryMethod}`;
        redirectURL += `&paymentMethod=${data.paymentMethod}`;
        if (data.epuapAddress) {
          redirectURL += `&epuapAddress=${data.epuapAddress}`;
        }
        redirectURL += `&bankAccountId=${data.bankAccountId}`;
        if (data['isSigned']) {
          return <td key={`${v}${i}`}><a type="submit-lg" className="btn btn-default" href={redirectURL} style={buttonStyle}>Zapłać</a></td>;
        } else {
          return <td key={`${v}${i}`}>{paymentMethod.label}</td>;
        }
      }
      return <td key={`${v}${i}`}>Niewymagana</td>;
    }
    if (v === 'teryt') {
      const district = _.find(
        this.props.districts,
        dist => dist.teryt.toString() === data[v],
      );
      if (district) {
        return <td key={`${v}${i}`}>{this.props.districts[district.prefix].name}</td>;
      }
      return <td key={`${v}${i}`}>{data[v]}</td>;
    }
    if (v === 'parcels') {
      return <td key={`${v}${i}`}>{data[v].length}</td>;
    }
    if (v === 'docCount') {
      return <td key={`${v}${i}`}>{data.documents.length}</td>;
    }
    if (v === 'actions') {
      if (data.documents.length > 0) {
        return <td key={`${v}${i}`}><a type="submit-lg" className="btn btn-default" href={`${process.env.API_URL}/eservices/getJobDocs/${data.jobId}`} style={buttonStyle}>Pobierz</a></td>;
      }
      return <td key={`${v}${i}`}><a type="submit-lg" disabled="true" className="btn btn-default" style={buttonStyle}>Pobierz</a></td>;
    }
  };

  renderRow = (v, i) => {
    const number = i + 1 + (this.state.docs_page_counter * (this.state.page - 1));
    return (
      <tr key={i}>
        <td>{number}</td>
        {this.state.visible_columns.map((col, col_index) => this.renderCol(col, col_index, v))}
      </tr>
    );
  };

  renderPagination = () => {
    const pageCount = this.state.pages.pages;
    const current = this.state.page;

    let start = 1;
    let end = pageCount;
    const diff = 5;

    if (pageCount >= 2 * diff) {
      if (current + diff >= pageCount) {
        start = pageCount - 2 * diff + 1;
        end += 1;
      }
      if (current >= diff && current + diff <= pageCount) {
        start = current - diff + 1;
        end = current + diff;
      }
      if (current < diff) {
        start = 1;
        end = 1 + 2 * diff;
      }
    } else {
      end = pageCount + 1;
    }
    if (start === 1 && end === 1) end += 1;

    return (
      <Pagination>
        <Pagination.First
          disabled={this.state.page === 1}
          onClick={() => this.setPage(1)}
        />
        <Pagination.Prev
          disabled={this.state.page === 1}
          onClick={() => this.state.page !== 1 ? this.setPage(this.state.page - 1) : null}
        />
        {_.range(start, end).map((v, i) => (
          <Pagination.Item key={i} onClick={() => this.setPage(v)} active={v === this.state.page}>
            {v}
          </Pagination.Item>
        ))}
        <Pagination.Next
          disabled={this.state.page === pageCount}
          onClick={() => this.state.page !== pageCount ? this.setPage(this.state.page + 1) : null}
        />
        <Pagination.Last
          disabled={this.state.page === pageCount}
          onClick={() => this.setPage(pageCount)}
        />
      </Pagination>
    );
  };

  renderStandard = () => {
    return (
      <div className={s.mdContainer} style={this.state.style}>
        <Row>
          <Col xs={12}>
            <PageHeader>
              <small>Zastosuj filtry aby wyszukać sprawę</small>
            </PageHeader>
          </Col>
        </Row>
        <Row>
          <Col xs={3}>
            <h4>Data wygenerowania</h4>
          </Col>
          <Col xs={1}>
            <select
              className="form-control needsclick"
              style={{ width: 'auto' }}
              value={this.state.operator}
              onChange={this.changeOperator}
            >
              {Object.keys(operator_map).map((v, i) => (
                <option key={i} value={operator_map[v]}>
                  {v}
                </option>
              ))}
            </select>
          </Col>
          <Col xs={3} style={{ color: 'black' }}>
            <DatePicker
              onChange={this.handleChange}
              value={this.state.date}
              placeholder="DD-MM-YYYY"
              monthLabels={polishMonthLabels}
              dayLabels={polishDayLabels}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <h4>Status</h4>
          </Col>
          <Col xs={3}>
            <select className="form-control needsclick" value={this.state.status} onChange={this.changeStatus}>
              <option />
              <option>niedokończony</option>
              <option>zakończony</option>
            </select>
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <h4>Status płatności</h4>
          </Col>
          <Col xs={3}>
            <select
              className="form-control needsclick"
              value={this.state.paymentStatus}
              onChange={this.changePaymentStatus}
            >
              <option />
              <option>niewymagana</option>
              <option>niedokończona</option>
              <option>przelewem</option>
              <option>w kasie urzędu</option>
              <option>oczekuje</option>
              <option>opłacono</option>
            </select>
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <h4>Jednostka Administracyjna</h4>
          </Col>
          <Col xs={8}>
            <Select
              placeholder="Wybierz gminę"
              multi
              rows={40}
              name="form-field-name"
              value={this.state.selected_districts}
              options={this.state.districts_options}
              clearable={false}
              onChange={this.logChangeDistrict}
              onBlur={event => event.preventDefault()}
              optionClassName="needsclick"
              blurInputOnSelect={false}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <h4>Usługi</h4>
          </Col>
          <Col xs={8}>
            <Select
              placeholder="Wybierz usługi"
              multi
              rows={40}
              name="form-field-name"
              value={this.state.selected_services}
              options={this.state.services_options}
              clearable={false}
              onChange={this.logChange}
              onBlur={event => event.preventDefault()}
              optionClassName="needsclick"
              blurInputOnSelect={false}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <h4>Sortuj według</h4>
          </Col>
          <Col xs={3}>
            <Select
              placeholder="Sortuj wg..."
              name="form-field-name"
              editable="false"
              value={this.state.orderingOption}
              options={orderingOptions}
              onChange={this.orderingChange}
              onBlur={event => event.preventDefault()}
              optionClassName="needsclick"
              blurInputOnSelect={false}
            />
          </Col>
        </Row>

        {this.state.user_claims ? (
          <Row style={{ marginTop: '20px' }}>
            <Col xs={12}>
              <Table condensed>
                <thead>
                  <tr>
                    <th>#</th>
                    {this.state.visible_columns.map((v, i) => {
                      if (v !== 'actions') return <th key={i}>{col_header_map[v]}</th>;
                      if (
                        v === 'actions' &&
                        this.props.userData &&
                        this.props.userData.roles &&
                        this.props.userData.roles.indexOf('superadmin') > -1
                      ) {
                        return <th key={i}>{col_header_map[v]}</th>;
                      }
                    })}
                  </tr>
                </thead>
                <tbody>{this.state.user_claims.map((v, i) => this.renderRow(v, i))}</tbody>
              </Table>
            </Col>
          </Row>
        ) : null}
        {this.state.pages ? (
          <Row style={{ textAlign: 'center' }}>
            <Col xs={1} style={{ marginTop: '20px' }}>
              <span>Na stronie: </span>
            </Col>
            <Col xs={1} style={{ marginTop: '20px' }}>
              <input
                className="form-control"
                value={this.state.per_page}
                onChange={e =>
                  this.setState({ per_page: e.target.value, apply_button_disabled: false })
                }
              />
            </Col>
            <Col xs={1} style={{ marginTop: '20px' }}>
              <button
                type="submit-lg"
                className="btn btn-default"
                disabled={this.state.apply_button_disabled}
                style={{ float: 'right', marginRight: '15px' }}
                onClick={() => this.applyButton(1)}
              >
                Zastosuj
              </button>
            </Col>
            <Col xs={8}>{this.renderPagination()}</Col>
            <Col xs={1} style={{ marginTop: '20px' }}>
              <div>
                {this.state.page}/{this.state.pages.pages}
              </div>
            </Col>
          </Row>
        ) : null}
      </div>
    );
  }

  renderOnMobile = () => {
    return (
      <div className={s.mdContainer} style={this.state.style}>
        <Row>
          <Col xs={12}>
            <PageHeader>
              <small>Zastosuj filtry aby wyszukać sprawę</small>
            </PageHeader>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h4>Data wygenerowania</h4>
          </Col>
        </Row>
        <Row style={{ marginBottom: '10px' }}>
          <Col xs={3}>
            <select
              className="form-control needsclick"
              style={{ width: 'auto' }}
              value={this.state.operator}
              onChange={this.changeOperator}
            >
              {Object.keys(operator_map).map((v, i) => (
                <option key={i} value={operator_map[v]}>
                  {v}
                </option>
              ))}
            </select>
          </Col>
          <Col xs={9} style={{ color: 'black' }}>
            <DatePicker
              onChange={this.handleChange}
              value={this.state.date}
              placeholder="DD-MM-YYYY"
              monthLabels={polishMonthLabels}
              dayLabels={polishDayLabels}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <h4>Status</h4>
          </Col>
          <Col xs={8}>
            <select className="form-control needsclick" value={this.state.status} onChange={this.changeStatus}>
              <option />
              <option>niedokończony</option>
              <option>zakończony</option>
            </select>
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <h4>Status płatności</h4>
          </Col>
          <Col xs={8}>
            <select
              className="form-control needsclick"
              value={this.state.paymentStatus}
              onChange={this.changePaymentStatus}
            >
              <option />
              <option>niewymagana</option>
              <option>niedokończona</option>
              <option>przelewem</option>
              <option>w kasie urzędu</option>
              <option>oczekuje</option>
              <option>opłacono</option>
            </select>
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <h4>Jednostka Administracyjna</h4>
          </Col>
          <Col xs={8}>
            <Select
              placeholder="Wybierz gminę"
              multi
              rows={40}
              name="form-field-name"
              value={this.state.selected_districts}
              options={this.state.districts_options}
              clearable={false}
              onChange={this.logChangeDistrict}
              onBlur={event => event.preventDefault()}
              optionClassName="needsclick"
              blurInputOnSelect={false}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <h4>Usługi</h4>
          </Col>
          <Col xs={8}>
            <Select
              placeholder="Wybierz usługi"
              multi
              rows={40}
              name="form-field-name"
              value={this.state.selected_services}
              options={this.state.services_options}
              clearable={false}
              onChange={this.logChange}
              onBlur={event => event.preventDefault()}
              optionClassName="needsclick"
              blurInputOnSelect={false}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <h4>Sortuj według</h4>
          </Col>
          <Col xs={8}>
            <Select
              placeholder="Sortuj wg..."
              name="form-field-name"
              editable="false"
              value={this.state.orderingOption}
              options={orderingOptions}
              onChange={this.orderingChange}
              onBlur={event => event.preventDefault()}
              optionClassName="needsclick"
              blurInputOnSelect={false}
            />
          </Col>
        </Row>

        {this.state.user_claims ? (
          <div style={{ overflowX: 'scroll' }}>
          <Table>
            <thead>
              <tr>
                <th>#</th>
                {this.state.visible_columns.map((v, i) => {
                  if (v !== 'actions') return <th key={i}>{col_header_map[v]}</th>;
                  if (
                    v === 'actions' &&
                    this.props.userData &&
                    this.props.userData.roles &&
                    this.props.userData.roles.indexOf('superadmin') > -1
                  ) {
                    return <th key={i}>{col_header_map[v]}</th>;
                  }
                })}
              </tr>
            </thead>
            <tbody>{this.state.user_claims.map((v, i) => this.renderRow(v, i))}</tbody>
          </Table>
          </div>
        ) : null}
        <Row style={{ textAlign: 'center' }}>
            <Col xs={4} style={{ marginTop: '20px' }}>
              <span>Na stronie: </span>
            </Col>
            <Col xs={4} style={{ marginTop: '20px' }}>
              <input
                className="form-control"
                value={this.state.per_page}
                onChange={e =>
                  this.setState({ per_page: e.target.value, apply_button_disabled: false })
                }
              />
            </Col>
            <Col xs={4} style={{ marginTop: '20px' }}>
              <button
                type="submit-lg"
                className="btn btn-default"
                disabled={this.state.apply_button_disabled}
                style={{ float: 'right', marginRight: '15px' }}
                onClick={() => this.applyButton(1)}
              >
                Zastosuj
              </button>
            </Col>
          </Row>
          <Row style={{ textAlign: 'center' }}>
            <Col xs={12}>{this.renderPagination()}</Col>
          </Row>
          <Row style={{ textAlign: 'center' }}>
            <Col xs={12} style={{ marginTop: '20px' }}>
              <div>
                {this.state.page}/{this.state.pages.pages}
              </div>
            </Col>
        </Row>
      </div>
    );
  }

  selectRenderMethod = () => {
    let isMobile = false;
    let isTablet = false;
    if (this.state.isMounted) {
      isMobile = isMobileView(window);
      isTablet = isTabletView(window);
    }

    return isMobile || isTablet ? this.renderOnMobile() : this.renderStandard();
  }

  render() {
    return this.state.pages ? this.selectRenderMethod() : (
      <GrayPanel
        title="Podsumowanie"
        bodyStyle={{ textAlign: 'center !important', marginTop: '100px', marginBottom: '100px' }}
      >
        <img role="presentation" src={waiting} />
      </GrayPanel>
    );
  }
}

const mapState = state => ({
  username: state.user ? state.user.username : '',
  districts: state.district.districts,
  eservices: state.eservices.eservices
});

export default withStyles(s)(connect(mapState)(MojeDokumenty));



// WEBPACK FOOTER //
// src/routes/mojeDokumenty/MojeDokumenty.js